import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, message, Checkbox, Radio, Modal } from 'antd';

const { TextArea } = Input;
const { Option } = Select;
const FormItem = Form.Item;

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};

const FindCostObjectForm = ({ updateState, handleFindByChange, handleOmnibusFieldChange, handleSearch, ...props }) => {
  const { getFieldDecorator, getFieldsError, getFieldsValue } = props.form;

  const invalidForm = () => {
    message.config({
      top: 150,
      duration: 5,
      maxCount: 5,
    });
    message.error('You have one or more invalid form inputs!');
  };

  const handleSubmit = (e) => {
    // e.preventDefault();
    const { costObjectName, costObjectNumber } = props.state.parameters;
    if ((!costObjectName && !costObjectNumber)
    || (costObjectName === '%' && costObjectNumber === '%')
    ) {
      Modal.warning({
        zIndex:3000,
        title: <p>Missing Search Criteria</p>,
        content: <p>Please enter a Cost Object Name or Number.</p>,
        onOk() {
          // do nothing
        },
      });
    } else {
      handleSearch();
    }
  };

  const resetPageNumber = () => {
    const { parameters } = props.state;
    parameters.pageNo = 0;
  }

    /**
     * populate fields on initial component mount
     * (getFieldDecorator overrides `value` on forms)
     */
    useEffect(() => {
    }, []);

      return (
          <Form onSubmit={handleSubmit}>

              <FormItem
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Radio.Group
                  name="findBy"
                  onChange={handleFindByChange} value={props.state.parameters.findBy}>
                  <Radio style={radioStyle} value={0}>
                  All
                  </Radio>
                  <Radio style={radioStyle} value={1}>
                  WBS Element
                  </Radio>
                  <Radio style={radioStyle} value={2}>
                  Cost Center
                  </Radio>
                  <Radio style={radioStyle} value={3}>
                  Default Cost Center
                  </Radio>
                  <Radio style={radioStyle} value={4}>
                  Project Definition
                  </Radio>
                </Radio.Group>
              </FormItem>

              <FormItem
                label={props.state.costObjectNameLabel}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Input
                  name="costObjectName"
                  onChange={handleOmnibusFieldChange}
                  size={'large'}
                  placeholder={'no wildcard (*) needed'}/>
              </FormItem>

              <FormItem
                label={props.state.costObjectNumberLabel}
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Input
                  name="costObjectNumber"
                  onChange={handleOmnibusFieldChange}
                  size={'large'}
                  placeholder={'no wildcard (*) needed'}/>
              </FormItem>

              { props.state.parameters.findBy === 1 &&
                <FormItem
                label="WBS Element Category"
                style={{ display: "flex", marginBottom: 5 }}
                >
                  <Select
                    name="category"
                    defaultValue={`category-${0}`}
                    onChange={handleOmnibusFieldChange}
                    style={{ width: 100 }}
                  >
                      <Option key={0} value={`category-${0}`}>All</Option>
                      <Option key={1} value={`category-${1}`}>Title</Option>
                      <Option key={2} value={`category-${2}`}>Non-Title</Option>
                  </Select>
                </FormItem>
              }

              <FormItem
                label="View Only Valid Items"
                style={{ display: "flex", marginBottom: 5 }}
              >
                <Checkbox
                  name="onlyValidItems"
                  checked={props.state.parameters.onlyValidItems}
                  onChange={handleOmnibusFieldChange}
                  size={'large'}
                />
              </FormItem>

              <FormItem
                style={{ marginTop: 20 }}
              >
                <Button type="primary" ghost block size={'large'}
                    onClick={() => {
                      resetPageNumber();
                      handleSubmit();
                    }}
                >
                  Find
                </Button>
              </FormItem>
          </Form>
      );
}

const WrappedFindCostObjectForm = Form.create()(FindCostObjectForm);

export default WrappedFindCostObjectForm;




// WEBPACK FOOTER //
// ./src/Components/Schedule/SelectCostObject/FindCostObjectForm.js